const EventCard = ({ event }) => {
	return (
		<div
			className='d-flex flex-column px-3 align-items-center'
			id='flyer'>
			<img
				src={event.src}
				alt={event.alt}
				width={350}
				height={350}
			/>
			{event.url !== "" && (
				<button
					type='button'
					className='btn'
					id='boton-inicio'
					onClick={() =>
						(window.location.href =
							event.url)
					}>
					Comprar tickets
				</button>
			)}
			<hr />
		</div>
	);
};

export default EventCard;
